import { render, staticRenderFns } from "./Suggestedlistings.vue?vue&type=template&id=65b41954&scoped=true&"
import script from "./Suggestedlistings.vue?vue&type=script&lang=ts&"
export * from "./Suggestedlistings.vue?vue&type=script&lang=ts&"
import style0 from "./Suggestedlistings.vue?vue&type=style&index=0&id=65b41954&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b41954",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VCardTitle,VImg})
